import CardNewsItem from "./card-news-item";

export default CardNewsItem;